<template>
  <div class="chat-component-contact" :class="{'active' : show}">
    <header class="header-chat">
      <avatar-component :src="avatar" :name="contacto.full_name || 'S/D'" :size="isScreenMovil ? 50 : 70"
        :sameBorder="false" :status="estado_user" />
      <section class="d-flex flex-column align-items-start justify-content-start">
        <strong class="nombre-autor">{{ contacto.full_name || 'S/D' }}</strong>
        <small class="estado-user text-nowrap d-flex align-items-center gap-50">
          {{ leyenda_estado }}
          <font-awesome-icon :icon="['fas', 'circle']" class="me-25" size="xs" color="black" />
          <span class="d-none d-md-flex"> Responde aprox. en: 25min.</span>
        </small>
        <b-button class="chat-btn-close" variant="text" @click="cerrarChat">
          <font-awesome-icon icon="fas fa-times" />
        </b-button>
      </section>
    </header>

    <main class="main-chat">
      <b-form @submit.prevent="enviarMensaje" class="form-chat" id="form-chat">
        <b-form-textarea class="text-area-chat" v-model="mensaje" v-bind="mensaje_attrs" :state="!errors.mensaje"
          :placeholder="`Haz una pregunta a ${contacto.full_name || ''} o comparte los detalles de tu proyecto; (requisitos,plazos, presupuesto y demás).`"></b-form-textarea>

        <b-form-invalid-feedback :state="!errors.mensaje">
          {{ errors.mensaje }}
        </b-form-invalid-feedback>

        <article class="opciones-text">
          <b-badge v-for="(t, i) in opciones_text.filter(v => !opciones_agregadas.includes(v))" :key="i"
            class="cursor-pointer text-white p-50" pill @click="agregarOpcionText(t)">
            {{ t }}
          </b-badge>
          <article class="d-flex justify-content-between mt-1">
            <small>Utiliza al menos 40 caracteres.</small>
            <small>{{ mensaje.length }} / 2500</small>
          </article>
        </article>
        <input type="file" hidden ref="refUploaded" v-bind="archivos_attrs" @input="nuevoArchivoAdjunto" />
      </b-form>

      <article class="adjuntos-chat" v-if="archivos.length">
        <strong>Archivos adjuntos ({{ archivos.length }})</strong>
        <article>
          <b-badge v-for="(archivo, index) in archivos" :key="index" class="d-flex align-items-center gap-50 justify-content-between"
            variant="primary" pill>
            <font-awesome-icon icon="fas fa-paperclip" class="me-25" />
            <span>{{ archivo && archivo.name ? (archivo.name.length > 15 ? '...' + archivo.name.slice(-15) :
              archivo.name) : '' }}</span>
            <b-button variant="text" size="sm" @click="quitarAdjunto(archivo)" style="height:30px;">
              <font-awesome-icon icon="fas fa-times" color="white" />
            </b-button>
          </b-badge>
        </article>

      </article>
    </main>

    <footer class="footer-chat">
      <b-button variant="text" size="sm" class="btn-adjunto" title="Solo puedes adjuntar 2 archivos" v-b-tooltip.hover
        @click="adjuntarArchivos">
        <font-awesome-icon icon="box-archive" size="lg" />
      </b-button>

      <b-button class="btn-enviar fuente-regular" type="submit" size="sm" variant="outline-primary"
        @click="enviarMensaje" :disabled="loading || mensaje.length < 40" form="form-chat">
        <font-awesome-icon icon="fas fa-paper-plane" class="me-50" />
        Enviar Mensaje
      </b-button>
    </footer>
  </div>
</template>

<script setup>

import avatarComponent from '@components/avatar.vue';
import useUtils from '@composables/useUtils';

const props = defineProps({
  show:{
    type: Boolean,
    required: false,
    default: false
  },
  contacto:{
    type: Object,
    required: false,
    default: () => ({})
  }
});


const {
  isScreenMovil,
  loading
} = useUtils();

const actions_chat = inject('actions_chat');
const {
  cerrarChat,
  mensaje,
  mensaje_attrs,
  archivos,
  archivos_attrs,
  errors,
  enviarMensaje
} = actions_chat;

const {contacto,show} = toRefs(props);
const refUploaded = ref(null)

const avatar = computed(() => {
  if (contacto.value && contacto.value.avatar) {
    return contacto.value.avatar;
  }
  return null;
});

const opciones_agregadas = ref([]);
const conectado = computed(() => {
  if (contacto.value?.conectado) {
    return contacto.value.conectado;
  }
  return false;
});



const estado_user = computed(() => {
  return conectado.value ? 'online' : 'offline';
});

const leyenda_estado = computed(() => {
  return conectado.value ? 'En línea' : 'Desconectado';
});

const opciones_text = ref([
  `👋 Hola, ${contacto.value.full_name ? contacto.value.full_name : 'estimado'}, ¿puedes ayudarme con: `,
  '¿Piensas que puedes entregar un pedido para el día: ',
  'Me gustaría encargar: ',
  'Estoy trabajando con un presupuesto de: '
]);

const agregarOpcionText = (t) => {

  opciones_agregadas.value.push(t);
  if (mensaje.value) {
    mensaje.value += ` ${t}`;
  } else {
    mensaje.value = t;
  }

};

watchEffect(() => {
  if(mensaje.value === '') {
    opciones_agregadas.value = [];
  }
});

const adjuntarArchivos = () => {
  console.log(refUploaded.value);
  refUploaded.value.click();
}

const nuevoArchivoAdjunto = (event) => {
  const files = event.target.files[0];
  if (!files) return;

  if (archivos.value.length >= 2 ) return ;

  const yaAgregado = archivos.value.some(a => a.name === files.name && a.size === files.size && a.type === files.type);

  if (!yaAgregado) {
    archivos.value.push(files);
  }
}

const quitarAdjunto = (archivo) => {
  archivos.value = archivos.value.filter(a => a !== archivo);
}



</script>

<style lang="scss" scoped>
@use "@variables/variables" as *;

.chat-component-contact{
  width:calc(100%  - 1rem);
  position:fixed;
  min-height: calc(100dvh - 35dvh);
  max-height:calc(100dvh - 20dvh);
  bottom:calc(-100% - 1rem);
  left: .5rem;
  z-index: 1000;
  background: $white;
  // padding: .5rem;
  border-radius: .5rem;
  transition: all .3s ease-in-out;
  display:flex;
  flex-direction:column;


  &.active{
    bottom: 1rem;
    box-shadow: 0 2px 10px rgba(0,0,0,0.3);
  }

  .header-chat {
    padding:1rem;
    border-bottom: 1px solid lighten($gris,40%);
    display:flex;
    justify-content:flex-start;
    align-items:center;
    gap:1rem;
    flex: 0 0 100px;

    .chat-btn-close{
      position: absolute;
      top: 0rem;
      right: 0rem;
      color: $gris;
      padding:.5rem 1rem;

      &:hover{
        background: lighten($danger, 40%);
        color: $dark;
      }
    }
  }

  .main-chat{

    flex: 1 1 auto;
    border-bottom: 1px solid lighten($gris,40%);
    position: relative;
    display:flex;
    flex-direction: column;

    .form-chat{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 1rem;
      height: inherit;
      width: 100%;
      flex:1 1 auto;
      padding: 1rem .5rem;
      overflow-y: scroll;
      .text-area-chat {
        field-sizing: content;
        background: transparent;
        border: none;
        list-style: none;
        box-shadow: none;
        resize: none;
        line-height: 1.2;
        font-size: 12pt;
    
        &:hover {
          box-shadow: none;
        }
      }
    
      .opciones-text {
        display: flex;
        flex-direction: column;
        gap: .5rem;
    
      }
    }

    .adjuntos-chat{
      flex:0 0 auto;
      height:auto;
      display: flex;
      padding: .5rem;
      flex-direction: column;
      align-items: flex-start;

      article{
        display:flex;
        flex-wrap: wrap;
        gap: .5rem;
        align-items: center;
      }
    }
    
  }

  .footer-chat{
    flex:0 0 70px;
    padding:1rem;
    display:flex;
    justify-content:space-between;
    align-items:center;

    .btn-adjunto{
      border-radius: 100%;
      height:50px;
      width:50px;
      padding:0px;
      &:hover{
        background: lighten($dark, 40%);
        color: $dark;

         & > svg{
          color: $white !important;
         }
      }
    }

  }

  @media (min-width: 792px) {
    width: 515px;
  }
}
</style>